import { render, staticRenderFns } from "./BatchModifyBrand.vue?vue&type=template&id=2d2d94e8&scoped=true"
import script from "./BatchModifyBrand.vue?vue&type=script&lang=js"
export * from "./BatchModifyBrand.vue?vue&type=script&lang=js"
import style0 from "./batch-modify.css?vue&type=style&index=0&id=2d2d94e8&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2d94e8",
  null
  
)

export default component.exports